<template>
  <div>
    <v-breadcrumbs :items="items1"></v-breadcrumbs>
    <v-alert v-if="errors" type="error">{{ errors }}</v-alert>
    <v-form @submit.prevent="dataSave()" ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" md="12">
          <v-col cols="4">
            <template>
              <div class="text-center">
                <v-btn
                    color="info"
                    class="ma-2 white--text"
                    @click="ot_discharge_print()"
                >
                  Print Certificate
                  <v-icon
                      right
                      dark
                  >
                    mdi-printer
                  </v-icon>
                </v-btn>
                <v-btn
                    color="success"
                    class="ma-2 white--text"
                    @click="patient_details()"
                >
                  Patient Details
                  <v-icon
                      right
                      dark
                  >
                    mdi-eye
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </v-col>
          <v-card>
            <template>
              <v-card>
                <v-card-title>
                  OT Patient Info:- <span>{{ get_schedule_data.id }}</span>
                  <v-spacer></v-spacer>

                </v-card-title>
                <v-col cols="12">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                      <tr>
                        <td>Patient ID</td>
                        <td>:</td>
                        <td class="">{{ get_schedule_data.patient_id }}</td>
                      </tr>
                      <tr>
                        <td>Patient Name</td>
                        <td>:</td>
                        <td class="">{{ get_patent_data.patient_name }}</td>
                      </tr>
                      <tr>
                        <td>Patient Phone</td>
                        <td>:</td>
                        <td class="">{{ get_patent_data && get_patent_data.patient_phone }}</td>
                      </tr>
                      <tr>
                        <td>Patient DOB</td>
                        <td>:</td>
                        <td class="">{{ get_patent_data.patient_dob }}</td>
                      </tr>
                      <tr>
                        <td>Patient Address</td>
                        <td>:</td>
                        <td class="">{{ get_patent_data.patient_address }}</td>
                      </tr>
                      <tr>
                        <td>Operation Name</td>
                        <td>:</td>
                        <td class="d-flex">{{ get_operation_data.name }}
                          <label class="ms-2"><input type="checkbox" v-model="submitData.operation_name_checked"/> Print or not</label>
                        </td>
                      </tr>
                      <tr>
                        <td>Operation Plan (Sub head)</td>
                        <td>:</td>
                        <td class="d-flex">{{ get_schedule_data.operation_subhead }}
                          <label class="ms-2"><input type="checkbox" v-model="submitData.subhead_name_checked" /> Print or not</label>
                        </td>
                      </tr>
                      <tr>
                        <td>Eye Type</td>
                        <td>:</td>
                        <td class="">{{ get_schedule_data.eye_type }}</td>
                      </tr>
                      <tr>
                        <td>IOL Box</td>
                        <td>:</td>
                        <td class="d-flex">
                          <label class="ms-2"><input type="checkbox" v-model="submitData.iol_box_checked" /> Print or not</label>
                        </td>
                      </tr>
                      <tr>
                        <td>Doctor:</td>
                        <td>:</td>
                        <td class="">{{ get_dr_data.dr_name }}</td>
                      </tr>
                      <tr>
                        <td>OT Date</td>
                        <td>:</td>
                        <td>{{ get_schedule_data.operation_date }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                </v-col>
              </v-card>
            </template>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-card >
            <v-col class="">
              <v-col v-bind:class="isOperationEyeBlock">
                <template>
                  <div><strong>Diagnosis Data</strong></div>
                </template>
              </v-col>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.diagnosis_left_eye"
                      label="Diagnosis (Left Eye)"
                      dense
                      outlined
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.diagnosis_right_eye"
                      label="Diagnosis (Right Eye)"
                      dense
                      outlined
                      hide-details
                  ></v-text-field>
                </v-col>
                <!--                <v-col cols="12" md="6">-->
                <!--                  <v-autocomplete-->
                <!--                      v-model="submitData.eye_type"-->
                <!--                      item-text="text"-->
                <!--                      item-value="value"-->
                <!--                      :items="diagnosis_eye"-->
                <!--                      label="Diagnosis Eye Type"-->
                <!--                      dense-->
                <!--                      outlined-->
                <!--                      chips-->
                <!--                  ></v-autocomplete>-->
                <!--                </v-col>-->
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.anesthesia"
                      label="Anesthesia"
                      placeholder="ex: L/A G/A SA/TA"
                      dense
                      outlined
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.anesthesia_dr_name"
                      label="Anesthesia Doctor Name"
                      dense
                      outlined
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.patient_diabetes"
                      label="Diagnosis (Systemic)"
                      placeholder="Diagnosis (Systemic)"
                      dense
                      outlined
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <template>
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="submitData.followup_date"
                            label="Followup Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="submitData.followup_date"
                          @input="menu = false"
                          @click:date="dateSelect"
                          :min="nowDate"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea v-model="submitData.diagnosis_note" outlined label="Note"></v-textarea>
                </v-col>
              </v-row>
            </v-col>
            <v-divider></v-divider>
            <v-col cols="12" md="12">
              <template>
                <v-row>
                  <v-col cols="3" md="3">
                    <div><strong>Treatment Topical Data</strong></div>
                  </v-col>
                  <v-col cols="3" md="3">
                    <v-btn color="primary" @click="addDropModal"> <v-icon>mdi-plus</v-icon>Add New Drop
                    </v-btn>
                  </v-col>
                  <v-col cols="3" md="3">
                    <v-btn color="success" @click="addDoseDuration"> <v-icon>mdi-plus</v-icon>Add New Dose & Duration
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
              <div
                  v-for="(input, index) in treatment_drops_selected"
                  :key="index"
                  class="input wrapper flex items-center"
              >
                <v-row>
                  <v-col
                      cols="12"
                      sm="6"
                      md="1"
                  >
                    <v-text-field
                        v-model="input.medicine_type"
                        label="Medicine Type"
                        dense
                        outlined
                        chips
                        placeholder="EYE DROP"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                        v-model="input.name"
                        item-text="name"
                        item-value="name"
                        :items="treatment_drops"
                        label="Medicine Drop"
                        dense
                        outlined
                        chips
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12"
                         sm="6"
                         md="2">
                    <v-autocomplete
                        v-model="input.right_eye"
                        item-text="name"
                        :items="medicine_doses"
                        label="Right Eye(Dose) "
                        placeholder="ex: 3 "
                        outlined
                        dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12"
                         sm="6"
                         md="2">
                    <v-autocomplete
                        v-model="input.duration_re"
                        item-text="duration"
                        :items="medicine_doses"
                        label="Duration Right Eye "
                        placeholder="ex: 1 drop 6 hourly  "
                        outlined
                        dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12"
                         sm="6"
                         md="2">
                    <v-autocomplete
                        v-model="input.left_eye"
                        item-text="name"
                        :items="medicine_doses"
                        label="Left Eye(Dose)"
                        placeholder="ex: 3 "
                        outlined
                        dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-autocomplete
                        v-model="input.duration_le"
                        item-text="duration"
                        :items="medicine_doses"
                        label="Duration Left Eye"
                        placeholder="ex: 1 drop 6 hourly"
                        outlined
                        dense
                    ></v-autocomplete>
                  </v-col>
                  <v-btn
                      class="ma-2 success"
                      text
                      icon
                      @click="addDrop(input, treatment_drops_selected)"
                      color="white lighten-2"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                      class="ma-2 error"
                      text
                      icon
                      v-show="treatment_drops_selected.length > 1"
                      @click="removeDrop(index, treatment_drops_selected)"
                      color="white lighten-2"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>

                </v-row>
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <template>
                <v-row>
                  <v-col cols="3" md="3">
                    <div><strong>Treatment Systemic Data</strong></div>
                  </v-col>
                  <v-col cols="3" md="3">
                    <v-btn color="primary" @click="addMedicineModal"> <v-icon>mdi-plus</v-icon>Add New Medicine
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
              <div
                  v-for="(input, index) in treatment_medicine_tab_selected"
                  :key="index"
                  class="input wrapper flex items-center"
              >
                <v-row>
                  <v-col
                      cols="12"
                      sm="6"
                      md="1"
                  >
                    <v-text-field
                        v-model="input.medicine_type"
                        label="Medicine Type"
                        dense
                        outlined
                        chips
                        placeholder="CAP/TAB"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"
                         sm="6"
                         md="3">
                    <v-autocomplete
                        v-model="input.name"
                        item-text="name"
                        item-value="name"
                        :items="treatment_medicines"
                        label="Medicine Tab/Cap"
                        dense
                        outlined
                        chips
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12"
                         sm="6"
                         md="3">
                    <v-text-field
                        v-model="input.rules"
                        label="Medicine Rules"
                        placeholder="ex: 1+0+1"
                        outlined
                        dense
                    ></v-text-field>

                  </v-col>
                  <v-col cols="12"
                         sm="6"
                         md="3">
                    <v-autocomplete
                        v-model="input.note"
                        item-text="duration"
                        :items="medicine_doses"
                        label="Duration"
                        placeholder="ex: 7 days"
                        outlined
                        dense
                    ></v-autocomplete>
                  </v-col>
                  <v-btn
                      class="ma-2 success"
                      text
                      icon
                      @click="addMedicine(input, treatment_medicine_tab_selected)"
                      color="white lighten-2"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                      class="ma-2 error"
                      text
                      icon
                      v-show="treatment_medicine_tab_selected.length > 1"
                      @click="removeMedicine(index, treatment_medicine_tab_selected)"
                      color="white lighten-2"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>

                </v-row>
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <template>
                <div><strong>Treatment Instruction</strong></div>
              </template>
              <v-col cols="12" sm="12">
                <v-combobox v-model="treatmentInstructionSelectedValue" :hide-no-data="!search" :items="treatment_instructions"
                            :search-input.sync="search" hide-selected label="Search for an option" multiple small-chips solo
                >
                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <v-chip v-if="item === Object(item)" v-bind="attrs" :input-value="selected" label small>
                      <v-icon class="pr-2" small @click="parent.selectItem(item)">
                        $delete
                      </v-icon>
                      <span >
                            {{ item.text }}
                          </span>

                    </v-chip>
                  </template>
                  <template v-slot:item="{ index, item }">
                    <v-text-field v-if="editing === item" v-model="editing.text" autofocus flat
                                  background-color="transparent" hide-details solo
                    ></v-text-field>
                    <v-chip v-else dark label small>
                      {{ item.text }}
                    </v-chip>
                    <v-spacer></v-spacer>
                  </template>
                </v-combobox>
              </v-col>
            </v-col>
            <v-divider></v-divider>
            <v-row align="center" justify="space-around">
              <v-btn class="mt-5 mb-5" depressed color="primary" type="submit">
                Update
              </v-btn>
            </v-row>
          </v-card>
        </v-col>


      </v-row>
    </v-form>
    <template>
      <div class="text-center">
        <v-dialog v-model="addNewSingleTreatmentModal" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> {{ modalLabel }}</v-card-title>
            <v-card-text>
              <v-text-field
                  v-model="addNewSingleTreatmentData.name"
                  label="Name"
                  required
              ></v-text-field>
              <v-text-field
                  v-model="addNewSingleTreatmentData.medicine_type"
                  label="Medicine Type"
                  placeholder="EYE DROP/TAB/CAP"
                  required
              ></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="dialogTreatmentModal()"> Cancel</v-btn>
              <v-btn color="primary" @click="addNewTreatmentSubmitData"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div class="text-center">
        <v-dialog v-model="addDoseDurationModal" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> {{ modalLabel }}</v-card-title>
            <v-card-text>
              <v-text-field
                  v-model="addDoseDurationData.name"
                  label="Add Dose"
                  required
              ></v-text-field>
              <v-text-field
                  v-model="addDoseDurationData.duration"
                  label="Add Duration"
                  placeholder="EYE DROP/TAB/CAP"
                  required
              ></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="dialogDoseDurationModal()"> Cancel</v-btn>
              <v-btn color="primary" @click="addNewDoseDurationData"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
<style scoped></style>
<script>
import atshq from "../../../../js/setup";
import moment from "moment/moment";

export default {
  name: "AddRemove",
  data() {
    return {


      menu: false,
      modal: false,
      menu2: false,
      modalLabel: '',
      addNewSingleTreatmentModal: false,
      addDoseDurationModal: false,
      addNewSingleTreatmentData: {
        name: '',
        medicine_type: '',
        treatment_type: ''
      },
      addDoseDurationData: {
        name: '',
        duration: '',
      },
      editing: null,
      treatment_drops: [],
      treatment_medicines: [],
      medicine_doses: [],
      treatment_instructions: [],
      treatmentInstructionSelectedValue: [],
      search: null,

      treatment_drops_selected: [{
        medicine_type: "EYE DROP",
        name: null,
        left_eye: "",
        right_eye: "",
        duration_re: "",
        duration_le: "",
        rules: "",
      }],
      treatment_medicine_tab_selected: [{
        medicine_type: null,
        name: null,
        rules: null,
        note: null
      }],
      dialog: false,
      ot_schedule_id: this.$route.params.id,
      isOperationEyeBlock: 'd-block',

      diagnosis_eye: [
        {
          text: "Left Eye",
          value: "Left Eye",
        },
        {
          text: "Right Eye",
          value: "Right Eye",
        },
        {
          text: "Both Eye",
          value: "Both Eye",
        }
      ],

      get_diagnosis_data: {},
      get_schedule_data: {},
      get_patent_data: {},
      get_operation_data: {},
      get_dr_data: {},

      submitData: {
        diagnosis: null,
        diagnosis_left_eye: null,
        diagnosis_right_eye: null,
        eye_type: null,
        anesthesia: null,
        anesthesia_dr_name: null,
        diagnosis_note: null,
        patient_diabetes: null,
        remarks: null,
        operation_name_checked: true,
        subhead_name_checked: true,
        iol_box_checked: false,
        followup_date: moment().format('YYYY-MM-DD'),
      },
      errors: null,
      error: null,
      valid: true,
      items1: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "OT Registration Details",
          disabled: false,
          href: "/ot-registration/" + this.$route.params.id,
        },
        {
          text: "OT Discharge Certificate",
          disabled: true,
          href: "OT Discharge Certificate",
        },
      ],
      nowDate: moment().format('YYYY-MM-DD'),
      returnUrl: atshq.defaults.headers.common.api_base_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.getRegData();
  },
  watch: {
    treatmentInstructionSelectedValue: {
      handler(val, prev) {
        // Handle undefined cases
        const current = Array.isArray(val) ? val : [];
        const previous = Array.isArray(prev) ? prev : [];

        if (current.length === previous.length) return;

        this.treatmentInstructionSelectedValue = current.map(v => {
          if (typeof v === 'string') {
            v = { text: v };
            this.treatment_instructions.push(v);
          }
          return v;
        });
      },
      deep: true
    }
  },
  methods: {
    addDrop() {
      this.treatment_drops_selected.push({
        name: null,
      });
    },
    removeDrop(index) {
      this.treatment_drops_selected.splice(index, 1);
    },

    addMedicine() {
      this.treatment_medicine_tab_selected.push({
        name: null,
      });

    },
    removeMedicine(index) {
      this.treatment_medicine_tab_selected.splice(index, 1);
    },

    getRegData() {
      atshq
          .get("/ot-schedule-data?ot_schedule_id=" + this.ot_schedule_id)
          .then((response) => {
            this.submitData = response.data.diagnosis_data
            this.get_schedule_data = response.data.schedule;
            this.treatment_instructions = response.data.treatment_instructions;
            this.treatmentInstructionSelectedValue = response.data.treatmentInstructionSelectedValue;
            this.get_patent_data = response.data.schedule.patient;
            this.get_operation_data = response.data.schedule.operation;
            this.get_dr_data = response.data.schedule.doctor;

            this.treatment_drops = response.data.treatment_drops;
            this.treatment_medicines = response.data.treatment_medicines;
            this.medicine_doses = response.data.medicine_doses;

            // get discharge data====

            if (response.data.treatmentDropsSelected.length > 0) {
              this.treatment_drops_selected=response.data.treatmentDropsSelected;
            }

            if (response.data.treatmentMedicinesSelected.length > 0) {
              this.treatment_medicine_tab_selected=response.data.treatmentMedicinesSelected;
            }

          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },

    dataSave() {
      atshq
          .post("ot-discharge-certificate", {
            formData: this.submitData,
            otschedule_id: this.get_schedule_data.id,
            patient_id: this.get_schedule_data.patient_id,
            treatment_drops_selected: this.treatment_drops_selected,
            treatment_medicine_tab_selected: this.treatment_medicine_tab_selected,
            treatmentInstructionSelectedValue: this.treatmentInstructionSelectedValue,
            user_id: localStorage.getItem("userId"),
          })
          .then((response) => {

            this.$noty.success(response.data.message);

          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          })
          .finally(() => {
            //Perform action in always
          });


    },
    ot_discharge_print() {
      window.open(
          this.returnUrl + "print/print-discharge-certificate/" + this.ot_schedule_id
      );
    },
    dateSelect() {
      return true;
    },
    patient_details() {

      window.open("/patient-details/" + this.get_schedule_data.patient_id, "_blank");
    },
    addDropModal() {
      this.addNewSingleTreatmentModal = true
      this.addNewSingleTreatmentData.treatment_type = 1
      this.modalLabel = "Add New Drop"
    },
    addDoseDuration() {
      this.addDoseDurationModal = true
      this.modalLabel = "Add Dose and Duration"
    },
    addMedicineModal() {
      this.addNewSingleTreatmentModal = true
      this.addNewSingleTreatmentData.treatment_type = 2
      this.modalLabel = "Add New Medicine"
    },
    dialogTreatmentModal(){
      this.addNewSingleTreatmentModal = false
    },
    dialogDoseDurationModal(){
      this.addDoseDurationModal = false
    },
    addNewTreatmentSubmitData() {
      atshq
          .post("discharge-treatment-default-store", {
            addNewSingleTreatmentData: this.addNewSingleTreatmentData,
            user_id: localStorage.getItem("userId"),
          })
          .then((response) => {
            this.$noty.success(response.data.message);
            this.addNewSingleTreatmentData.name = '';
            this.treatment_drops = response.data.treatment_drops;
            this.treatment_medicines = response.data.treatment_medicines;
            this.medicine_doses = response.data.medicine_doses;
            this.dialogTreatmentModal()
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          })
    },
    addNewDoseDurationData() {
      atshq
          .post("add-medicine-dose-and-duration", {
            addDoseDurationData: this.addDoseDurationData,
            user_id: localStorage.getItem("userId"),
          })
          .then((response) => {
            this.$noty.success(response.data.message);
            this.addDoseDurationData.name = '';
            this.addDoseDurationData.duration = '';
            this.dialogDoseDurationModal()
            this.getRegData()
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          })
    },

  },
};
</script>
